import { EMPTY, Observable, forkJoin, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CourseInterface } from '@app/interfaces/_index';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CourseService {
  private coursesURL = `${environment.api.kepler.docebo.url}/courses`;

  constructor(private http: HttpClient) {}

  /**
   * This function gives you the details about a course. The get_all_sessions parameter,
   * If set to 0 then expired sessions and sessions with max enrollments will be excluded
   * (sessions with overbooking will show). If set to 1 then all sessions, including expired ones, will be retrieved.
   * Default value is 1. We want to show expired and sold out sessions.
   * @param id course id
   * @returns - an Observable Course response
   */
  getCourse(id: number): Observable<CourseInterface | unknown> {
    const courseParams = new HttpParams().set('get_all_sessions', '1');
    return this.http
      .get<CourseInterface>(`${this.coursesURL}/${id}`, {
        params: courseParams,
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(
        catchError((err, _caught) => {
          console.error(err);
          return EMPTY;
        })
      );
  }

  /**
   * Return an observable collection of Courses by course ids
   * @param ids - collection of course ids to be processed
   * @returns - an Observable collection of Courses
   */
  getCourses(ids: number[]): Observable<CourseInterface[]> {
    const courses: Observable<CourseInterface | unknown>[] =
      ids?.map((id) => {
        return this.getCourse(id);
      }) || [];

    // Fork join the array of course id array and return as an array of
    // observables
    return forkJoin(courses).pipe(
      map((courses): CourseInterface[] => {
        // only include truthy courses
        return courses.filter((course) => !!course) as CourseInterface[];
      })
    );
  }
}
